import React from 'react';

export const IdentificationDocumentNote = () => (
  <ul className="list-short-notes">
    <li className="list-short-notes__item">
      ※アップロード可能なファイルの種類は「jpg / jpeg / png」のいずれかです
    </li>
    <li className="list-short-notes__item">
      ※ファイルサイズは1枚5MB以下にしてください
    </li>
    <li className="list-short-notes__item">
      ※ios11以降の端末で撮影した画像の場合、拡張子が「.HEIC」となりアップロードが行えない場合があります。
      <a href="/pages/faq" target="_blank" rel="noopener noreferrer" >よくあるご質問</a>
      「iPhoneで撮影した写真がアップロードできない場合」をご確認ください
    </li>
  </ul>
);
